import React, { useEffect, useRef, useState } from "react";
import API from "../../api/api";

const emptyForm = { name: "", designation: "", bio: "", sort_order: 0, is_active: true, remove_photo: false };

export default function ManageCommitteeMembers() {
  const [members, setMembers] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [photo, setPhoto] = useState(null);
  const [editing, setEditing] = useState(null);
  const [busy, setBusy] = useState(false);
  const photoInput = useRef(null);

  const load = async () => {
    try {
      const response = await API.get("/admin/committee-members", { params: { all: true } });
      setMembers(response?.data?.data || response?.data || response || []);
    } catch (_error) {
      setMembers([]);
    }
  };

  useEffect(() => { load(); }, []);

  const reset = () => {
    setForm(emptyForm);
    setPhoto(null);
    setEditing(null);
    if (photoInput.current) photoInput.current.value = "";
  };

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const payload = new FormData();
      Object.entries(form).forEach(([key, value]) => payload.append(key, typeof value === "boolean" ? (value ? "1" : "0") : value));
      if (photo) payload.append("photo", photo);
      await API.post(editing ? `/admin/committee-members/${editing.id}` : "/admin/committee-members", payload, { headers: { "Content-Type": "multipart/form-data" } });
      reset();
      load();
    } finally {
      setBusy(false);
    }
  };

  const edit = (member) => {
    setEditing(member);
    setForm({ name: member.name || "", designation: member.designation || "", bio: member.bio || "", sort_order: member.sort_order || 0, is_active: Boolean(member.is_active), remove_photo: false });
    setPhoto(null);
    if (photoInput.current) photoInput.current.value = "";
  };

  const remove = async (member) => {
    if (!window.confirm(`Delete “${member.name}”?`)) return;
    await API.delete(`/admin/committee-members/${member.id}`);
    if (editing?.id === member.id) reset();
    load();
  };

  return <main className="p-5 md:p-8 max-w-6xl mx-auto">
    <header className="rounded-2xl bg-gradient-to-r from-emerald-800 to-teal-700 px-6 py-5 text-white shadow-sm"><p className="text-xs font-black uppercase tracking-[.18em] text-emerald-100">Admin Workspace</p><h1 className="mt-1 text-3xl font-black">Committee Members</h1><p className="mt-1 text-emerald-50">Maintain the public committee directory shown in About.</p></header>
    <form onSubmit={submit} className="mt-7 grid md:grid-cols-2 gap-4 rounded-2xl border bg-white p-5 shadow-sm"><input required value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} placeholder="Member name" className="border rounded-lg px-3 py-2" /><input required value={form.designation} onChange={(event) => setForm({ ...form, designation: event.target.value })} placeholder="Designation" className="border rounded-lg px-3 py-2" /><textarea value={form.bio} onChange={(event) => setForm({ ...form, bio: event.target.value })} placeholder="Short profile / achievement" rows="4" className="border rounded-lg px-3 py-2 md:col-span-2" /><input ref={photoInput} type="file" accept="image/jpeg,image/png,image/webp" onChange={(event) => setPhoto(event.target.files?.[0] || null)} className="border rounded-lg px-3 py-2" /><input type="number" min="0" value={form.sort_order} onChange={(event) => setForm({ ...form, sort_order: event.target.value })} placeholder="Display order" className="border rounded-lg px-3 py-2" /><label className="flex items-center gap-2 text-sm font-semibold text-slate-700"><input type="checkbox" checked={form.is_active} onChange={(event) => setForm({ ...form, is_active: event.target.checked })} /> Published publicly</label>{editing?.photo_url ? <label className="flex items-center gap-2 text-sm font-semibold text-slate-700"><input type="checkbox" checked={form.remove_photo} onChange={(event) => setForm({ ...form, remove_photo: event.target.checked })} /> Remove current photo</label> : null}<div className="flex gap-3 md:col-span-2"><button disabled={busy} className="rounded-lg bg-emerald-700 text-white font-bold px-4 py-2 disabled:opacity-50">{busy ? "Saving…" : editing ? "Save Changes" : "Add Member"}</button>{editing ? <button type="button" onClick={reset} className="rounded-lg border px-4 py-2 font-bold">Cancel</button> : null}</div></form>
    <div className="mt-7 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{members.map((member) => <article key={member.id} className="overflow-hidden rounded-2xl border bg-white"><div className="h-44 bg-slate-100">{member.photo_url ? <img src={member.photo_url} alt={member.name} className="w-full h-full object-cover" /> : null}</div><div className="p-4"><h2 className="font-black text-slate-900">{member.name}</h2><p className="text-sm text-emerald-700 font-bold">{member.designation}</p><p className="mt-2 text-xs text-slate-500">Order {member.sort_order} · {member.is_active ? "Published" : "Hidden"}</p><div className="mt-4 flex gap-3"><button type="button" onClick={() => edit(member)} className="text-blue-700 font-bold text-sm">Edit</button><button type="button" onClick={() => remove(member)} className="text-rose-700 font-bold text-sm">Delete</button></div></div></article>)}</div>
  </main>;
}
